module.exports = __webpack_public_path__ + "static/media/anquanxiaozu1.82774686.jpg";